import { render, staticRenderFns } from "./TermsComponent.vue?vue&type=template&id=0020e823&scoped=true&"
import script from "./TermsComponent.vue?vue&type=script&lang=js&"
export * from "./TermsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0020e823",
  null
  
)

export default component.exports